export default __webpack_public_path__ + "static/media/circle_close-grey.c0f17d42.svg";